import React from 'react';
import styles from './Advantages.module.css';
import advantage1 from '../../../src/img/preim_001.png';
import advantage2 from '../../../src/img/preim_002.png';
import advantage3 from '../../../src/img/preim_003.png';

const Advantages = () => {
  const advantages = [
    {
      image: advantage1,
      title: '100% подтверждение',
      description: 'гостиничных чеков как в бухгалтерии клиента, так и в нашей гостинице.'
    },
    {
      image: advantage2,
      title: 'Реальная гостиница',
      description: 'в Челябинске для оптимизации расходов на командировку.'
    },
    {
      image: advantage3,
      title: 'Всё для вашего отчета',
      description: 'по окончании командировки: чек с qr, счет 3 Г, акт, прайс, УПД'
    }
  ];

  return (
    <section id="advantages" className={styles.advantages}>
      <div className="container">
        <div className={styles.advantagesHeader}>
          <h2 className={styles.sectionTitle}>Наши преимущества</h2>
        </div>
        
        <div className={styles.advantagesGrid}>
          {advantages.map((advantage, index) => (
            <div key={index} className={`card ${styles.advantageCard}`}>
              <div className={styles.advantageImage}>
                <img src={advantage.image} alt={advantage.title} />
              </div>
              <div className={styles.advantageContent}>
                <h3 className={styles.advantageTitle}>{advantage.title}</h3>
                <p className={styles.advantageDescription}>{advantage.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className={styles.advantagesFooter}>
          <div className={styles.footerText}>
            Мы более 15 лет в гостиничном бизнесе и сформировали уверенный коллектив, состоящий из квалифицированного 
            административного и сервисного персонала с богатым опытом. Имеющаяся материально техническая база и 
            арендуемые коммерческие площади позволяют комфортно размещать достаточное количество гостей, одновременно 
            позволяя клиентам оформлять гостичные чеки и без заселения в номерной фонд.
          </div>
        </div>
      </div>
      <div className={styles.advantagesDivider}></div>
    </section>
  );
};

export default Advantages;